import { useEffect } from 'react';
import { getInitialSpots } from '../hooks/useStudySpots';

const ImagePreloader = () => {
  useEffect(() => {
    const preloadImages = async () => {
      const spots = await getInitialSpots();
      spots.forEach(spot => {
        if (spot.images && spot.images.length > 0) {
          const img = new Image();
          img.src = spot.images[0];
        }
      });
    };

    preloadImages();
  }, []);

  return null; // This component doesn't render anything
};

export default ImagePreloader; 